<div 
    *ngIf="isScan" 
    class="app-wrapper"
>

    <div 
        *ngIf="showHeader" 
        class="scan-header"
    >
        <span>{{ errorMessage }}</span>
        <ng-template #title></ng-template>
    </div>

    <div class="scanner-display">
        <div 
            id="scanner" 
            [style]="'height: ' + height"
        ></div>
    </div>

    <div 
        *ngIf="showResults" 
        class="scan-results"
    >
        <div 
            *ngIf="codeDetection" 
            class="scan-detection" 
            (click)="removeCodeDetection()"
        >
            <div class="scan-results-type-name">{{ codeDetection.typeName }}</div>
            <div class="scan-results-data">{{ codeDetection.data }}</div>
        </div>
    </div>

</div>

<br />

<div 
    *ngIf="
        initialized 
        && !barcodeReader
    " class="scan-actions"
>
    <button 
        [disabled]="busy" 
        class="btn btn-save btn-lg" 
        (click)="startScanning()"
    >{{ scanningBtnText }}</button>
</div>
<div 
    *ngIf="
        initialized 
        && barcodeReader 
        && showCloseButton
    " 
    class="scan-actions"
>
    <button 
        [disabled]="busy" 
        class="btn btn-save btn-lg" 
        id="closeScanner" 
        (click)="closeScanning()"
    >Close Scanner</button>
</div>
